import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router";
import { useApolloClient, useQuery } from "@apollo/client/react";
import { ActiveQuestionnairesWithoutElementDocument } from "@/graphql/generated/operations";
import { BackButton } from "@/components/common/BackButton";
import { QuestionnaireRunner } from "@/components/grow/QuestionnaireRunner";

// One part of the Power Quiz (15 items): meta from the element-free list,
// answering via the shared runner. After submit the part list's answered
// flags are refetched so the overview reflects the new state immediately.

export function PowerQuizPartPage() {
  const navigate = useNavigate();
  const client = useApolloClient();
  const { questionnaireId = "" } = useParams();

  const { data } = useQuery(ActiveQuestionnairesWithoutElementDocument);
  const meta = (data?.activeQuestionnairesWithoutElement ?? []).find(
    (p) => p.questionnaire.questionnaireId === questionnaireId,
  )?.questionnaire;

  return (
    <section
      className="mx-auto max-w-screen-md px-4 py-12"
      data-graphql="ActiveQuestionnairesWithoutElement, QuestionnaireQuestions, SaveQuestionnaireResults"
    >
      <div className="mb-5">
        <BackButton />
      </div>
      <QuestionnaireRunner
        questionnaireId={questionnaireId}
        name={meta?.name}
        instructions={meta?.instructions}
        eyebrow={<FormattedMessage id="grow.play.quiz.eyebrow" defaultMessage="Grow · Play" />}
        onSubmitted={() => {
          void client.refetchQueries({ include: [ActiveQuestionnairesWithoutElementDocument] });
          navigate("/grow/play/power-quiz");
        }}
      />
    </section>
  );
}
